import Vue from 'vue';
import App from './App.vue';
import { BdsApiService } from './services';

import 'bootstrap-scss';
import { IConfig } from './models';

Vue.config.productionTip = false;

import './index.scss';

export function setup(config: IConfig) {

  Vue.component('intro', config.intro);

  new Vue({
    render: (h) => h(App),
    provide() {
      const bdsApiService = new BdsApiService(config.baseUrl);
      return {
        bdsApiService,
        config,
      };
    },
    created() {
      document.title = config.title;
    },
    methods: {
      getCredentials() {
        if (window.location.pathname.startsWith('/survey/')) {
          const [,, customerId, token] = window.location.pathname.split('/');
          return { customerId, token };
        }

        const {customerid: customerId, token} = window.location.search
          .substring(1)
          .split('&')
          .map(x => x.split('=').map(decodeURIComponent))
          .reduce((a, [key, value]) => (a[key.toLowerCase()] = value, a), {});

        return {customerId, token};
      }
    }
  }).$mount('#app');
}


